import React from "react";
import { useNavigate } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import "react-phone-input-2/lib/style.css";
import { FaArrowRight } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { addToCart } from "../../../redux/actions/CartActions";
import FormalityHeader from "../../../components/header/FormalityHeader";
import "../../styles/flow-form.css";

// Validation schema
const validationSchema = Yup.object({
  businessName: Yup.string().required("Le nom de l'entreprise est requis"),
});

function OapiBusinessName() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const cart = useSelector((state) => state.cart);

  const handleSubmit = async (values) => {
    await dispatch(
      addToCart({
        businessName: values.businessName,
      })
    );

    navigate("/oapi-business-address");
  };

  return (
    <div className="legacy-flow">
      <FormalityHeader from={cart.from} />
      {/* Title Section */}
      <div className="container mt-4 mb-4 text-center">
        <h4 className="text-2xl font-semibold">
          Quel est le <span style={{ color: "#FF5500" }}>nom</span> pour votre{" "}
          {cart?.businessType} ?
        </h4>
      </div>

      {/* Form Section */}
      <div className="container mt-4 d-flex justify-content-center">
        <Formik
          initialValues={{
            businessName: "",
          }}
          validationSchema={validationSchema}
          onSubmit={async (values) => {
            handleSubmit(values);
          }}
        >
          {({ setFieldValue, errors, touched, values }) => (
            <Form className="w-100" style={{ maxWidth: "500px" }}>
              <div className="mb-3">
                <Field
                  name="businessName"
                  className="form-control"
                  placeholder="Nom de l'entreprise"
                  style={{ height: "50px" }}
                />
                {errors.businessName && touched.businessName && (
                  <div className="text-danger">{errors.businessName}</div>
                )}
              </div>

              <div className="d-flex justify-content-center mt-4">
                <button
                  type="submit"
                  className="btn btn-primary"
                  style={{
                    backgroundColor: "#051259",
                    borderRadius: "10px",
                    color: "#fff",
                    width: "180px",
                    padding: "10px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  Suivant
                  <FaArrowRight style={{ marginLeft: "8px" }} />
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
}

export default OapiBusinessName;
